import { FunctionComponent, useState } from "react"
import { Alert, Button, Col, Modal } from "react-bootstrap"
import { useRefreshKeycardDoorsQuery } from "../hooks/queries/useRefreshKeycardDoorsQuery"
import { SortDirection } from "../hooks/useSort"

interface IRecalculateKeycardDoorsButton {
	setActiveFilter: (active: string) => void
	sortBy: (sort: string, sortDirection: SortDirection) => void
	setAutoRefresh: (refresh: boolean) => void
}
const RecalculateKeycardDoorsButton: FunctionComponent<IRecalculateKeycardDoorsButton> = ({
	setActiveFilter,
	sortBy,
	setAutoRefresh,
}) => {
	const { query, data, loading, error } = useRefreshKeycardDoorsQuery()
	const [show, setShow] = useState(false)
	return (
		<>
			<Modal show={show} onHide={() => setShow(false)}>
				<Modal.Header closeButton={true}>
					<Modal.Title>Update</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{error && <Alert variant="warning">Error applying changes</Alert>}
					Normal changes to Residents, Employees, and Vendors are applied immediately. Changes to Roles, Passes, Doors,
					and Access Controllers are only applied overnight. If you need to apply those changes immediately, or need to
					refresh those changes, push the button below. It will take 15-20 minutes to update. Please do not run this
					again during that time.
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShow(false)}>
						Cancel
					</Button>
					<Col></Col>
					<Button
						variant="primary"
						disabled={data || loading}
						onClick={async () => {
							//the refresh function takes over 2 minutes to finish, so API Gateway will return an error after 30 seconds
							await query({ queryParameters: ["all-access-controllers=true"] })
							//keep the modal open for a total of 2:30
							await new Promise((resolve) => setTimeout(resolve, 120 * 1000))
							//
							setShow(false) //close modal
							setActiveFilter("Enabled") //hide disabled controllers
							sortBy("status.updateInProgress", SortDirection.DESC) //show controllers that are updating
							setAutoRefresh(true) //start auto-refresh
						}}>
						{!data && !loading ? "Update" : "Updating..."}
					</Button>
				</Modal.Footer>
			</Modal>
			<Button variant="primary" onClick={() => setShow(true)}>
				Update Access Controllers
			</Button>
		</>
	)
}
export default RecalculateKeycardDoorsButton
